import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { observer } from "mobx-react";
import { Form } from "semantic-ui-react";
import TourLayoutWrapper from "../components/TourLayoutWrapper";
import TourNav from "../constants/TourNav";
import MlsServiceStore from "../../../stores/MlsService/MlsServiceStore";
import FormInput from "../components/FormInput";
import FormSelect from "../components/FormSelect";
import SaveButton from "../components/SaveButton";
import "../styles/Mls.less";
import TourStore from "~/stores/TourStore";
import ModalUnsavedConfirmation from "~/components/element/ModalUnsavedConfirmation";
import Loader from "../components/Loader";
import ContentLoader from "~/components/element/ContentLoader";
import LoadingWrapper from "~/components/wrapper/LoadingWrapper";
import User from "~/models/User";
import StickyMenu from "~/components/StickyMenu";
import ToastMessageStore from "~/stores/ToastMessageStore";

@observer
class Mls extends Component {
  constructor(props) {
    super(props);
    document.title = "Tour - MLS";
  }

  componentDidMount() {
    const { mlsServiceStore, user } = this.props;
    if (!mlsServiceStore.mlsServices.length) {
      mlsServiceStore.getAll({ providerId: user.provider.providerId });
    }
    window.scrollTo(0, 0);
  }

  save() {
    const { t, tourStore, toastMessageStore } = this.props;

    tourStore.save().then(() => {
      toastMessageStore.addToastMessage(t("changesSaved"), "positive", t("success"));
    });
  }

  render() {
    const { tourStore, mlsServiceStore, t, tourLayoutContentContainerRef } = this.props;
    if (mlsServiceStore.isLoading) {
      return <ContentLoader />;
    }

    return (
      <>
        <ModalUnsavedConfirmation
          when={tourStore.hasUnsavedData}
          onSave={() => this.save()}
          onDiscard={() => tourStore.reset()}
        />
        <LoadingWrapper loading={tourStore.isSaving} message={t("saving")} />

        <StickyMenu
          contextRef={tourLayoutContentContainerRef}
          headerText={t("clientPanelMisc:mls")}
          button={<SaveButton disabled={!tourStore.hasUnsavedData} onClick={() => this.save()} />}
        />

        <Loader active={tourStore.isLoading} page content={t("loading")} />
        <Form>
          <div className="mls-form-container">
            <FormSelect
              label={t("clientPanelInfo:mlsService")}
              options={mlsServiceStore.displayNameFormOptions}
              placeholder={t("clientPanelInfo:selectMlsService")}
              name="tour.mlsServiceId"
              dataStore={tourStore}
            />
            <FormInput label={t("clientPanelInfo:mlsNumber")} name="tour.mlsNumber" dataStore={tourStore} />
          </div>
        </Form>
      </>
    );
  }
}

Mls.propTypes = {
  tourStore: PropTypes.instanceOf(TourStore),
  mlsServiceStore: PropTypes.instanceOf(MlsServiceStore),
  user: PropTypes.instanceOf(User),
  t: PropTypes.func.isRequired,
  tourLayoutContentContainerRef: PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  toastMessageStore: PropTypes.instanceOf(ToastMessageStore),
};

export default withTranslation()(TourLayoutWrapper(Mls, TourNav.MLS));
